// Schedule.js
import React, { useState } from "react";
import Header from "../HomeHeader/Header";
import "./Schedule.css";
import Tree from "../../HomeScreenDetail/Tree";
import Scheduler from "../../HomeScreenDetail/Schedule.jsx";
import { Splitter, SplitterPanel } from "primereact/splitter";
import PlaylistScheduleHeader from "../../HomeScreenDetail/PlaylistScheduleHeader";
export default function Schedule({ScheduleinfoSelectedRowValue}) {

  const [newid, SetNewid] = useState("");
  const [newname, SetNewName] = useState("");
  const [nodekeyLevel, setNodekeyLevel] = useState("");
  const [scheduleHdrId, setScheduleHdrId] = useState("");
  const [schedulename, setSchedulename] = useState(""); 
  function onclicheck(value) {
    if (value !== undefined) getSelectedRowdatas(value);
  }
  function getSelectedRowdatas(selectedRowsData) {
    setScheduleHdrId(selectedRowsData.ScheduleHdrId);
    setSchedulename(selectedRowsData.Schedulename);
  }
  function onclickchecktreeData(value) {
    if (value !== undefined) getSelectedTreeRowdatas(value);
  }
  function getSelectedTreeRowdatas(selectedTreedata) {
    SetNewid(selectedTreedata.id);
    SetNewName(selectedTreedata.name);
    setNodekeyLevel(selectedTreedata.nodekeylevel);
  }
  
  return (
    <div>
      <Header />
      <Splitter>
        <SplitterPanel
          size={20}
          minSize={20}
          className="flex align-items-center justify-content-center"
        >
          <Tree onclickcheck={onclickchecktreeData} ScheduleinfoSelectedRowValue={ScheduleinfoSelectedRowValue}/>
        </SplitterPanel>
        <SplitterPanel
          size={30}
          minSize={30}
          className="flex align-items-center justify-content-center"
        >
          <PlaylistScheduleHeader
            selectednewid={"1"}
            selectednewName={"Schedule"}
            onclickcheck={onclicheck}
          />
        </SplitterPanel>
        <SplitterPanel
          size={50}
          minSize={50}
          className="flex align-items-center justify-content-center"
        >
          <Scheduler
          ScheduleinfoSelectedRowValue={ScheduleinfoSelectedRowValue}
            selectednewid={newid}
            selectednewLibrayName={newname}
            newNodekeyLevel={nodekeyLevel}
            hidedragicon={"HiddendragIcon"}
            scheduleHdrId={scheduleHdrId}
            schedulename={schedulename}
          />
        </SplitterPanel>
      </Splitter>
    </div>
  );
}
